module.exports = __webpack_public_path__ + "img/uminho_usp_ufscar.c1b57c3d.png";